import type { RootScope } from '../types';

let $rootScope: RootScope;

export const setRootScope = (scope: RootScope) => {
  $rootScope = scope;
};

export const getRootScope = (): RootScope => {
  if (!$rootScope) {
    throw new Error('$rootScope was not injected');
  }

  return $rootScope;
};

let $compileProvider: angular.ICompileProvider;
const compileProviderQueue: ((provider: angular.ICompileProvider) => void)[] =
  [];

export const setCompileProvider = (provider: angular.ICompileProvider) => {
  $compileProvider = provider;

  const queue = compileProviderQueue.slice();
  compileProviderQueue.length = 0;

  queue.forEach((cb) => cb(provider));
};

export const getCompileProvider = (): angular.ICompileProvider => {
  if (!$compileProvider) {
    throw new Error('$compileProvider was not injected');
  }

  return $compileProvider;
};

export const getCompileProviderAsync = () => {
  // fake promise interface because we need completely sync API because
  // angular initializes synchronously and if we'll use Promise will get into
  // micro-task queue which will cause us to resolve after the initial render
  // which is too late
  let reject: (error: Error) => void = () => {};

  const api = {
    then(cb: (provider: angular.ICompileProvider) => void) {
      // do not allow second call
      api.then = () => api;

      try {
        cb(getCompileProvider());
      } catch (error) {
        const timeoutId = setTimeout(() => {
          reject(new Error('Timeout waiting for CompileProvider'));
        }, 5000);

        compileProviderQueue.push((provider) => {
          clearTimeout(timeoutId);
          cb(provider);
        });
      }

      return api;
    },
    catch(cb: (error: Error) => void) {
      // do not allow second call
      api.catch = () => api;

      reject = cb;

      return api;
    },
  };

  return api;
};
